import { Heading } from "src/components/ui/heading"
import { css } from "styled-system/css"

export default function App() {
  return (
    <article class={css({
      display: 'grid',
      gap: 3
    })}>
      <p>Our <strong>Sniper Circle</strong> Mobile App is available for Android and Apple iOS.</p>

      <p><strong>Important Note:</strong> The mobile app should be seen as an extension of the full web version of thesnipercircle.com website. As such it does not have all the functionality of the web version but you will be able to follow all the chat room discussions with it and it will give notifications when there are updates to a discussion which you are following.</p>

      <p>Should you prefer to have the full user experience you will need to revert to the web version.</p>

      <p>Once installed you’ll need to log in with the same login credentials used to log in to the main web-version of the site. You may only have one concurrent login to the web version and one login to the mobile app version at any given time. Please note that should you login to the <strong>Sniper Circle</strong> Mobile App with another phone or device, it will automatically log you out of the initial open session and you will no longer receive notifications on that device.</p>

      <Heading textStyle='2xl' my={6}>Installing on Android</Heading>

      <p>
        <a href="https://thesnipercircle.com/wp-content/uploads/2025/02/The_Sniper-Circle_3.1.1.zip">
          <img
            class="alignleft"
            src="https://spcdn.shortpixel.ai/spio/ret_img,q_cdnize,to_webp,s_webp/thesnipercircle.com/wp-content/uploads/2023/12/android-icon100x100.png"
            alt="Android App Icon"
            width="51"
            height="57"
          />
        </a>
        Tap the Android icon to the left whilst viewing this page on your Android mobile device to download the ZIP file directly to your device. Alternatively, download the file to your PC/Mac and copy it to your Android device.<br />
        Unzip the file.<br />
        Use <a href="https://play.google.com/store/apps/details?id=com.lb.app_manager&amp;pcampaignid=web_share">App Manager</a> or <a href="https://play.google.com/store/apps/details?id=com.wuliang.xapkinstaller&amp;pcampaignid=web_share">XAPK Installer</a> to install the <strong>Sniper Circle</strong> Mobile App on your device.
      </p>

      <Heading textStyle='2xl' my={6}>Installing on Apple iOS</Heading>

      <p>
        <a href="https://itunes.apple.com/app/sniper-circle/id1356135254">
          <img
            class="alignleft"
            src="https://spcdn.shortpixel.ai/spio/ret_img,q_cdnize,to_webp,s_webp/thesnipercircle.com/wp-content/uploads/2023/12/apple-app-store-icon100x100.png"
            alt="Apple App Store Icon"
            width="48"
            height="48"
          />
        </a>
        Tap the Apple iOS icon to the left whilst viewing this page on your Apple iOS mobile device to go to the relevant installation page or search for “<strong>Sniper Circle</strong>” on the Apple iTunes Store to find the app and install it, then log in with your current login credentials for the web interface.
      </p>

    </article>
  )
}
